import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgSearch({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 19 21"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d="M7.885 0c4.355 0 7.885 3.784 7.885 8.452 0 2.215-.795 4.231-2.096 5.738l4.08 4.373a1.087 1.087 0 0 1 0 1.462l-.123.131a.92.92 0 0 1-1.364 0l-4.221-4.524a7.464 7.464 0 0 1-4.161 1.271C3.53 16.903 0 13.12 0 8.452 0 3.784 3.53 0 7.885 0Zm0 2.254c-3.193 0-5.782 2.775-5.782 6.198 0 3.423 2.589 6.198 5.782 6.198 3.194 0 5.782-2.775 5.782-6.198 0-3.423-2.588-6.198-5.782-6.198Z" />
        </svg>
    )
}
SvgSearch.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgSearch
